import React from 'react';
import styles from '../styles.module.css'; // default import

function AdminBlog() {
  return (
    <div className={styles.mainSection}>
      Under Development
    </div>
  );
}

export default AdminBlog;
